'use strict';
import addToCart from './product/addToCart';
import productTile  from '../product-tile';

function initTutorialCarousel() {
	$('.related-carousel-wrapper .tutorial-wrapper').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: true,
		arrows: false,
		responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
					dots: true
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
					dots: true
				}
			}
		]
	});

	if ($("#thumbnails li").length == 0) {
		return false;
	} else if ($("#thumbnails li").length > 1 && window.innerWidth > 767) {
		tutorialThumbnailCarousel();
	} else if ($("#thumbnails li").length > 1 && window.innerWidth < 768) {
		tutorialMainImageCarousel();
	}
	tutorialImages();
}

function tutorialThumbnailCarousel() {
	$('#thumbnails ul').slick({
		dots: false,
		infinite: true,
		arrows: true,
		vertical: true,
		slidesToShow: 4,
		slidesToScroll: 1
	});
}

function tutorialMainImageCarousel() {
	$("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
	$('#thumbnails ul').slick({
		dots: true,
		vertical: false,
		infinite: true,
		arrows: false,
		centerMode: false,
		slidesToShow: 1
	});
}

// tutorial image carousel
function tutorialImages() {
	$("#thumbnails").on('click', '.productthumbnail', function () {
		var $that = $(this);

		$("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
		$that.addClass('selected');
		setTutorialMainImage($that.find('img').attr('src'));
	});
}

function setTutorialMainImage(src) {
	$('#tutorial-image-template .primary-image').attr('src', src);
}

export default {
	init: function () {
		initTutorialCarousel();
		addToCart();
		productTile.init();

	}
};